var _rect, _rect2, _g, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 128,
    viewBox: "0 0 160 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 24,
    width: 89,
    height: 88,
    rx: 8,
    fill: "#D7E0EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 16,
    width: 41,
    height: 16,
    rx: 6,
    fill: "#A27A5F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#357653",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44 49 4 4 8-9M44 69l4 4 8-9M44 89l4 4 8-9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 49h33M68 69h26M68 89h30",
    stroke: "#A6B2C2",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 96,
    r: 19,
    fill: "#DEEEE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m110 96 7 7 13-15",
    stroke: "#357653",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureValue);
export default __webpack_public_path__ + "static/media/feature-value.177d63ee427b3375ed04581033985e0f.svg";
export { ForwardRef as ReactComponent };